import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import fileApi from '../../api/file.api';

type Props = {
  contentState: EditorState;
  onEditorStateChange: (editorState: EditorState) => void;
};

export function RichEditor(props: Props) {
  const { contentState, onEditorStateChange } = props;

  const handleImageUpload = async (file: File) => {
    const res = await fileApi.upload(file);
    const url = process.env.REACT_APP_API_URI + res.data.path;

    return { data: { link: url } };
  };

  return (
    <Editor
      editorState={contentState}
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="draft-editor content"
      onEditorStateChange={onEditorStateChange}
      toolbar={{
        options: [
          'inline',
          'blockType',
          'fontSize',
          'fontFamily',
          'list',
          'textAlign',
          'link',
          'embedded',
          'emoji',
          'image',
          'remove',
          'history',
        ],
        fontFamily: {
          options: [
            'Segoe UI',
            'Roboto',
            'Open Sans',
            'Lato',
            'Poppins',
            'Inter',
            'Montserrat',
            'Source Sans Pro',
            'Ubuntu',
            'Noto Sans',
            'Merriweather',
            'Playfair Display',
            'Oswald',
            'Raleway',
            'Quicksand',
            'Arial',
            'Times New Roman',
            'Georgia',
            'Verdana',
            'Courier New',
          ],
        },
        image: {
          uploadEnabled: true,
          uploadCallback: handleImageUpload,
          alt: { present: true, mandatory: false },
          previewImage: true,
          alignmentEnabled: true,
          inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
          defaultSize: {
            height: 'auto',
            width: 'auto',
          },
        },
      }}
    />
  );
}
